"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        id: 1,
        position: 1,
        shipmentId: 45,
        tourId: 1,
    },
    {
        id: 2,
        position: 2,
        shipmentId: 46,
        tourId: 1,
    },
    {
        id: 3,
        position: 3,
        shipmentId: 47,
        tourId: 1,
    },
    {
        id: 4,
        position: 4,
        shipmentId: 48,
        tourId: 1,
    },
    {
        id: 5,
        position: 5,
        shipmentId: 49,
        tourId: 1,
    },
    {
        id: 7,
        position: 1,
        shipmentId: 47,
        tourId: 5,
    },
    {
        id: 6,
        position: 2,
        shipmentId: 48,
        tourId: 5,
    },
];
